<template>
  <div>
    <manage-version v-if="openVersionDisplayDialog" @close="closeVersionDisplayDialog" :fileInfo="selectedFileToViewVersions" @openPreviewOfMedia="openPreviewOfMedia"></manage-version>
    <div style="width:100%;">
      <template v-if="uploadedFilesList != undefined && uploadedFilesList.length">  
          <template v-for="files in uploadedFilesList">
            <div class="d-flex mb-2 progressbar-wrapper"  :key="files">
            <template v-if="mapUploadedFilesWithUuid[uniqueId].includes(files.fileUID)">
              <div class="file-name-with-progress-bar-wrapper" :class="files.status == 'INITIALIZING' || files.status == 'INPROGRESS' ? 'upload-in-progress':''" :id="files.fileUID" :file-data="files" :style='customizeStyles?customizeStyles:""'>
                <div class="file-name-wrapper d-inline-flex" style="height:auto;">
                    <div class="file-icon-progress-bar-wrapper">
                      <div v-if="files.proxy_info.thumbnail_uri != undefined && files.proxy_info.thumbnail_uri.length" class="thumbnail-view" v-on:dblclick='openPictureInPicture(mapFileDetailsWithFileUid[files.fileUID])' style="width:125px;margin-inline-end:10px;">
                        <img :src="getThumbnailPath(files)" @error="replaceByDefaultImage"  alt="image" draggable="false" style="width:100%"/>
                        <div v-if="files.state && files.state == 'OUTDATED'" class="outdated-text">
                          >{{$t('OUTDATE')}}D
                        </div>
                        <div class="storage-type-icons-wrapper">
                          <svg v-if="isActionEnable('Download') && uniqueId == 'tasksIssuesDescription'" @click="handleDownloadAction(mapFileDetailsWithFileUid[files.fileUID])" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                              <title>>{{$t('Download')}}</title>
                              <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                              <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                          </svg>
                          <svg @click="openPictureInPicture(mapFileDetailsWithFileUid[files.fileUID])" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                              <path d="M0 0h24v24H0V0z" fill="none"/>
                              <title>>{{$t('Preview')}}</title>
                              <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                          </svg>
                          <svg v-if="enableAnnotation && uniqueId == 'attachMediaToMessage'" xmlns="http://www.w3.org/2000/svg" @click.stop.prevent="annotateAttachment(files)" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                              <title>>{{$t('Edit media')}}</title>
                              <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                          </svg>
                          <svg @click="openProperties(files)" v-if="requiredMenu && requiredMenu.includes('properties')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <title>>{{$t('Properties')}}</title>
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                          </svg>
                          <svg v-if="files.state && files.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(files)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                            <title>>{{$t('View versions')}}</title>
                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                          </svg>
                        </div>
                      </div>
                      <div
                        v-else
                        v-html="getSvgIconsOfMediaTypes(files)" 
                        class="svg-icons-display"
                      >
                      <div v-if="files.state && files.state == 'OUTDATED'" class="outdated-text">
                        >{{$t('OUTDATED')}}
                      </div>
                        <div class="storage-type-icons-wrapper">
                          <svg v-if="isActionEnable('Download') && uniqueId == 'tasksIssuesDescription'" @click="handleDownloadAction(mapFileDetailsWithFileUid[files.fileUID])" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                              <title>>{{$t('Download')}}</title>
                              <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                              <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                          </svg>
                          <svg @click="openProperties(files)" v-if="requiredMenu && requiredMenu.includes('properties')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                          </svg>
                          <svg v-if="files.state && files.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(files)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                            <title>>{{$t('View versions')}}</title>
                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                          </svg>
                        </div>
                      </div>        
                    </div>
                    <div style="width:calc(100% - 125px)" class="file-name-details-wrapper">
                      <div class="file-name-display" :title="files.fileName">{{files.fileName}}</div><div style="float:inline-start"><span class="file-size-display">{{ humaniseSize(files.fileSize)}}</span><span class="file-size-display">{{"  |  " + getDateAndTimeInConfiguredFormat(files.createdTime)}}</span></div>
                      <div class="progress-bar-wrapper" v-if="files.status == 'INPROGRESS'">
                        <div class="progress-percentage-display">{{Math.round(files.uploadPercentage) + "%"}}</div>
                        <div class="progress">
                                    <div class="progress-bar" role="progressbar" :style="{width:files.uploadPercentage + '%'}" :aria-valuenow="files.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="progress-speed-display">
                            {{files.bandwidth.bandwidth}} {{files.bandwidth.unit}}
                        </div>    
                    </div>
                    </div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131" v-if="files.status == 'FAILED'" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                    <title>>{{$t('Failed to attach')}}</title>
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="files.status == 'INITIALIZING'" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                  <title>>{{$t('INITIALIZING')}}</title>
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#eee" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromUpload(files.fileUID,files.status,files.fileName)" viewBox="0 0 16 16">
                  <title>>{{$t('Remove File')}}</title>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            
              </div>
          </template>
            </div>
          </template>
      </template>
      <template v-else-if="uploadedFilesList.length === 0 && file_name_data_temp_list.length">  
              <template v-for="files in file_name_data_temp_list">
                <div class="d-flex mb-2 upload-unInitialized" v-if="files != null" :key="files">
                <div  class="file-name-with-progress-bar-wrapper" :id="files" :file-data="files" :style='customizeStyles?customizeStyles:""'>
                  <div class="file-name-wrapper d-inline-flex" style="height:auto;">
                      <div
                        v-html="getSvgIconsOfMediaTypes(files)" 
                        class="svg-icons-display"
                      >
                      </div>
                      <div style="width:calc(100% - 125px)" class="file-name-details-wrapper">
                        <div class="file-name-display" :title="files.name">{{files.name}}</div><div style="float:inline-start"><span class="file-size-display">{{ humaniseSize(files.size)}}</span><span class="file-size-display"></span></div>
                      </div>
                  </div>
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                      <title>>{{$t('Failed to attach</title>
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                  </svg> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                    <title>>{{$t('QUEUED')}}</title>
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#eee" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromAlreadyUploadedFiles(null,files.name)" viewBox="0 0 16 16">
                    <title>>{{$t('Remove File')}}</title>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
              </div>
                </div>
              </template>
      </template>
       <template v-if="attachedFilesList != undefined">  
              <template v-for="files in attachedFilesList">
                <div class="d-flex mb-2 attached-file-main-wrapper" v-if="files != null && files.file_uid" :key="files">
                <div  class="file-name-with-progress-bar-wrapper" :id="files.file_uid" :file-data="files" :style='customizeStyles?customizeStyles:""'>
                  <div class="file-name-wrapper d-inline-flex" style="height:auto;">
                    <div style="display:flex">
                      <div v-on:dblclick='openPictureInPicture(files)' class="thumbnail-view" style="width:125px;margin-inline-end:10px;" :style="files.state && files.state == 'OUTDATED' && latestFileVersions && latestFileVersions[files.asset_id]?'opacity:0.5':''">
                        <img :src="getThumbnailPath(files)" @error="replaceByDefaultImage" alt="image" draggable="false" style="width:100%"/>
                        <div v-if="'mime_type' in files && files.mime_type && (files.mime_type.startsWith('video') || files.mime_type.startsWith('audio')) && 'duration' in files && files.duration"
                          class="comm-thumbnail-view-duration-label">
                          {{getHumanReadableDuration(files.duration)}}
                        </div>
                        <div v-if="!files.state || (files.state && files.state == 'READY')" class="storage-type-icons-wrapper">
                            <svg v-if="isActionEnable('Download') && uniqueId == 'tasksIssuesDescription'" @click="handleDownloadAction(files)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                <title>{{$t('Download')}}</title>
                                <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                            </svg>
                            <svg @click="openPictureInPicture(files)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <title>>{{$t('Preview')}}</title>
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                            </svg>
                            <svg v-if="enableAnnotation && uniqueId == 'attachMediaToMessage'" xmlns="http://www.w3.org/2000/svg" @click.stop.prevent="annotateAttachment(files)" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                              <title>>{{$t('Edit media')}}</title>
                              <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                            </svg>
                            <svg @click="openProperties(files)" v-if="requiredMenu && requiredMenu.includes('properties')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                            </svg>
                            <svg v-if="getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(files)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                              <title>>{{$t('View versions')}}</title>
                              <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                            </svg>
                        </div>
                      </div>
                      <template v-if="files.state && files.state == 'OUTDATED'">
                        <div v-on:dblclick='openPictureInPicture(latestFileVersions[files.asset_id])' class="thumbnail-view" style="width:125px;margin-inline-end:10px;margin-inline-start: -123px;margin-top: 10px;">
                          <img :src="getThumbnailPath(latestFileVersions[files.asset_id])" @error="replaceByDefaultImage" alt="image" draggable="false" style="width:100%"/>
                          <div class="outdated-text">
                            V-{{latestFileVersions[files.asset_id].versions.length}}
                          </div>
                          <div v-if="'mime_type' in latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].mime_type && (latestFileVersions[files.asset_id].mime_type.startsWith('video') || latestFileVersions[files.asset_id].mime_type.startsWith('audio')) && 'duration' in latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].duration"
                            class="comm-thumbnail-view-duration-label">
                            {{getHumanReadableDuration(latestFileVersions[files.asset_id].duration)}}
                          </div>
                          <div class="storage-type-icons-wrapper">
                              <svg v-if="isActionEnable('Download') && uniqueId == 'tasksIssuesDescription'" @click="handleDownloadAction(latestFileVersions[files.asset_id])" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                  <title>>{{$t('Download')}}</title>
                                  <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                  <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                              </svg>
                              <svg @click="openPictureInPicture(latestFileVersions[files.asset_id])" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                  <path d="M0 0h24v24H0V0z" fill="none"/>
                                  <title>>{{$t('Preview')}}</title>
                                  <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                              </svg>
                              <svg v-if="enableAnnotation && uniqueId == 'attachMediaToMessage'" xmlns="http://www.w3.org/2000/svg" @click.stop.prevent="annotateAttachment(latestFileVersions[files.asset_id])" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                                <title>>{{$t('Edit media')}}</title>
                                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                              </svg>
                              <svg @click="openProperties(latestFileVersions[files.asset_id])" v-if="requiredMenu && requiredMenu.includes('properties')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                              </svg>
                              <svg v-if="getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(latestFileVersions[files.asset_id])" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                <title>>{{$t('View versions')}}</title>
                                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                              </svg>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div style="width:calc(100% - 125px)" class="file-name-details-wrapper">
                      <div class="file-name-display" :title="latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].slug_name?latestFileVersions[files.asset_id].slug_name:files.slug_name">{{latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].slug_name?latestFileVersions[files.asset_id].slug_name:files.slug_name}}</div><div style="float:inline-start"><span class="file-size-display">{{ humaniseSize(latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].size?latestFileVersions[files.asset_id].size:files.size)}}</span><span class="file-size-display">{{"  |  " + getDateAndTimeInConfiguredFormat(latestFileVersions[files.asset_id] && latestFileVersions[files.asset_id].created_datetime?latestFileVersions[files.asset_id].created_datetime:files.created_datetime)}}</span></div>
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#eee" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromAlreadyUploadedFiles(files.file_uid,files.slug_name)" viewBox="0 0 16 16">
                    <title>>{{$t('Remove File')}}</title>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
              </div>
                </div>
              </template>
      </template>
      </div>
  </div>
</template>
<script>
import Utils from "../../components.utils";
import {mapActions,mapMutations,mapGetters} from "vuex";
import FileUploaderToCloud from "../../plugins/fileUploadToCloud.js"
import FileUploder from "../../plugins/fileUploader.js";
import Constants from "../../components.constants.js";
//import ManageVersionsDialog from "../ManageVersions/ManageVersionsDialog.vue";

export default {
        data(){
            return {
                enableAnnotation:true,
                selectedFilenames:null,
                file_name_data:[],
                file_name_data_temp_list:[],
                // eslint-disable-next-line no-useless-escape
                specialCharactersToBeAvoided: new RegExp(/[*|\/":<>\\?]/),
                uploadDetails:null,
                filesUploadResponse:null,
                mapFileUIdWithFileData:{},
                uploadedFilesList:[],
                mapUploadedFilesWithUuid:{},
                uploadPercentage:0,
                bandWidth:0,
                uploadedFilesListTemp:{},
                attachedFilesList:[],
                removeAttachmentCheck:false,
                mapFileDetailsWithFileUid:{},
                isAbortRequested:false,
                selectedFileToViewVersions:null,
                openVersionDisplayDialog:false,
                latestFileVersions:{}
            }
        },
        //components: {"manage-version":ManageVersionsDialog},
        props:['selectedFilesFromAttachBrowse','uniqueId','alreadyAttachedFiles','enableDeleteIcon','emptyfiles','customizeStyles','abortInProgressUpload', 'customUploadPath', 'disableAnnotation','customUploadInfo',"requiredMenu"],
        watch:{
            customUploadInfo(newVal){
              this.uploadDetails = {"responseData": newVal, "binId":newVal.upload_path.split("share://")[1].split("/")[0]};
            },
            selectedFilesFromAttachBrowse(newVal){
                this.selectedFilenames = newVal;
                this.uploadSelectedFileToGivenPath(newVal)
            },
            alreadyAttachedFiles(newVal){
                if(this.uniqueId == 'tasksIssuesDescription'){
                  this.uploadedFilesList = [];
                  this.file_name_data_temp_list = [];
                  this.emptyOldFiles();
                  this.attachedFilesList = newVal;
                }else{
                  this.attachedFilesList = this.attachedFilesList.concat(newVal);
                }
                
                this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList,true);
            },
            emptyfiles(newVal){
              if(newVal){
                this.uploadedFilesList = [];
                this.file_name_data_temp_list = [];
              }
            },
            abortInProgressUpload(newVal){
              if(newVal){
                var els = document.getElementsByClassName("upload-in-progress");
                let that = this;
                Array.prototype.forEach.call(els, function(el) {
                    let getFileUid = el.getAttribute('id');
                    let payload = {};
                    if(that.mapFileUIdWithFileData[getFileUid]){
                      payload = {file_uid:getFileUid,job_id:that.mapFileUIdWithFileData[getFileUid].job_id};
                      that.abortUpload({"job_id": that.mapFileUIdWithFileData[getFileUid].job_id,"data":payload});
                      if(that.uploadedFilesList && getFileUid)that.uploadedFilesList = that.uploadedFilesList.filter(e => e.fileUID != getFileUid); 
                    }
                    that.$emit("abortedInProgressFiles")
                });
              }
            },
            attachedFilesList: {
              handler(list) {
                list?.forEach(file => {
                  if (
                    file.state === "OUTDATED" &&
                    file.asset_id &&
                    !this.latestFileVersions[file.asset_id]
                  ) {
                    this.fetchLatestFileVersion(file);
                  }
                });
              },
              deep: true,
              immediate: true
          }
        },
        computed:{ 
          startupData:{
            get(){
              return this.$store.state.startUpData.startUpDataDetails;
            }
          },
          getLatestVrsionInfo(){
                return this.latestFileVersions;
          },
            ...mapGetters("upload",["getAllJobs"]),
            ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
            ...mapGetters("users",["getLoggedInUserPrivilege"]),
            ...mapGetters("versions",["getVersionInfoDisplayCheck"])
        },
        methods:{
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("jobs", ["createNewJob"]),
            ...mapActions("upload",["initiateUploadBySubmittingAction"]),
            ...mapMutations("upload",["addToUploadList", "startUpload", "abortUpload", "handleUploadExit","setFileUploaderState","setFileUploadToCloudState","removeFailedFiles","emptyOldFiles"]),
            ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
            ...mapActions("assets",["getAssetInfoFromServer"]),
            fetchLatestFileVersion(file){
              let payload = {params:{assetId: file.asset_id}}
              this.getAssetInfoFromServer(payload).then((data) => {
                if (data.statusCode==200){
                  this.$set(this.latestFileVersions, file.asset_id, data.asset);
                }else{
                  this.$toast.error(data.message);
                }
              })
            },
            getNewerVersionNumber(fileInfo){
              if(fileInfo){
                let fIndex =  fileInfo.versions.findIndex(version => version.version_id === fileInfo.version_id);
                if(fIndex > -1){
                  return 'V'+fileInfo.versions[fIndex].version_number;
                }
              }
            },
            openProperties(fileInfo){
              this.$emit('openProperties',fileInfo);
            },
            openManageVersions(file){
                this.openVersionDisplayDialog = true;
                this.selectedFileToViewVersions = file;
            },
            closeVersionDisplayDialog(){
                this.openVersionDisplayDialog = false;
                this.selectedFileToViewVersions = null;
            },

            replaceByDefaultImage(e){
              e.target.onerror = null
              e.target.src = Utils.getNoThumbnailImg();
            },
            getFilenameWithUuid: function(fileName){ 
              let file_name = fileName;
              let lastIndexOfDot = file_name.lastIndexOf('.');
              let extension = file_name.slice(lastIndexOfDot, file_name.length);
              let namePart = file_name.slice(0,lastIndexOfDot);
              return namePart +'_'+ Utils.getUUID() + extension;
            },
            uploadSelectedFileToGivenPath(files){
                    let selectedFilenames = files;
                    this.file_name_data = selectedFilenames;
                    for (let i = 0; i < selectedFilenames.length; i++) {
                        this.file_name_data_temp_list.push(selectedFilenames[i])
                        let payload = {};
                        payload.job_name = "Upload";
                        payload.element_type = "file";
                        payload.group_id = this.uploadDetails.responseData.group_id;
                        payload.upload_token = this.uploadDetails.responseData.upload_token;
                        payload.upload_url = this.uploadDetails.responseData.upload_url;
                        payload.file_name = this.startupData.enable_reference_id_workflow?selectedFilenames[i].name:this.getFilenameWithUuid(selectedFilenames[i].name);
                        payload.size = selectedFilenames[i].size;
                        payload.path = this.uploadDetails.responseData.upload_path;
                        payload.bin_id = this.uploadDetails.binId;
                        if(this.customUploadPath && 'catalogUploadPath' in this.customUploadPath && this.customUploadPath.catalogUploadPath){
                            payload["catalog_id_path"] = this.customUploadPath.catalogUploadPath;
                        }else{
                          if(Object.keys(this.uploadDetails.responseData).includes("upload_category") && Object.keys(this.uploadDetails.responseData.upload_category).length){
                            if(this.uploadDetails.responseData.upload_category.parent_id_path && this.uploadDetails.responseData.upload_category._id){
                              payload["catalog_id_path"] = [this.uploadDetails.responseData.upload_category.parent_id_path + "/" + this.uploadDetails.responseData.upload_category._id];
                            }
                          }
                        }  
                        if(this.specialCharactersToBeAvoided.exec(selectedFilenames[i].name) != null){
                          alert('File name containing any of these <>:"|/?*\\ characters are skipped');
                          continue;
                        }
                        this.createNewJob(payload).then((data)=>{
                        if(!Utils.isAcceptedStatusCode(data.statusCode)){
                                this.$toast.error(data.message);
                        }
                        this.filesUploadResponse = data;
                        this.mapFileUIdWithFileData[this.filesUploadResponse.data.file_uid] = this.filesUploadResponse;
                        if (Utils.isAcceptedStatusCode(data.statusCode)){
                            if(Object.keys(this.filesUploadResponse.data.upload_url).includes("fields")){
                                let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(selectedFilenames[i],this.filesUploadResponse.data.upload_url,this.filesUploadResponse,this.uploadDetails,this.filesUploadResponse.created_datetime,payload.file_name);
                                this.addToUploadList({"job_id":this.filesUploadResponse.job_id,"uploader": limitUploadToCloud,"uuid":this.uniqueId});
                                if(!this.mapUploadedFilesWithUuid[this.uniqueId]){
                                  this.mapUploadedFilesWithUuid[this.uniqueId] = [];
                                }
                                this.mapUploadedFilesWithUuid[this.uniqueId].push(this.filesUploadResponse.data.file_uid);
                                this.startUpload();
                            }else{
                                let uploader = this.handleFileUpload(selectedFilenames[i],this.uploadDetails.responseData.upload_path,this.uploadDetails.responseData.upload_token,this.filesUploadResponse.data.session_id,this.filesUploadResponse.data.file_uid,this.filesUploadResponse.job_id,this.uploadDetails.responseData.upload_url,this.filesUploadResponse.created_datetime,payload.file_name);
                                this.addToUploadList({"job_id":this.filesUploadResponse.job_id,"uploader": uploader});    
                                if(!this.mapUploadedFilesWithUuid[this.uniqueId]){
                                  this.mapUploadedFilesWithUuid[this.uniqueId] = [];
                                }
                                this.mapUploadedFilesWithUuid[this.uniqueId].push(this.filesUploadResponse.data.file_uid);
                                this.startUpload()
                            }
                        }else{
                                this.$toast.error(data.message);
                            }
                        }); 
                    }
            },
            handleFileUpload(fileDetails,uploadUrl,uploadToken,sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName) {
                let uploader = new FileUploder(fileDetails, uploadUrl,uploadToken, sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName, false)
                uploader.on("progress", this.handleProgress);
                uploader.on("fileUploadDone", this.handleCompleted);
                uploader.on("complete", this.handleSuccess);
                uploader.on("fail", this.handleFail);
                uploader.on("exit", this.handleExit);
                return uploader;
            },
            uploadToCloudThroughProvidedUrl(file,uploadFields,filesUploadDataFromResponse,uploadResponse,createdTime,fileName){ 
                let uploader = new FileUploaderToCloud(file,uploadFields,uploadResponse,filesUploadDataFromResponse,createdTime,fileName,false);
                uploader.on("progress", this.handleProgress);
                uploader.on("complete", this.handleSuccess);
                uploader.on("fileUploadDone", this.handleCompleted);
                uploader.on("fail", this.handleFail);
                uploader.on("exit", this.handleExit);
                return uploader;
            },
            discardSelectedFileFromUpload(fileUid,status,name){
              if(status != "INPROGRESS"){
                this.removeFailedFiles(this.mapFileUIdWithFileData[fileUid].job_id);
                this.uploadedFilesList = Object.values(this.getAllJobs);
                this.discardSelectedFileFromAlreadyUploadedFiles(fileUid,name)
              }else{
                if(confirm(`Are you sure you want to abort selected file?`)){
                    let payload = {};
                    payload = {file_uid:fileUid,job_id:this.mapFileUIdWithFileData[fileUid].job_id};
                    this.abortUpload({"job_id": this.mapFileUIdWithFileData[fileUid].job_id,"data":payload});
                    this.discardSelectedFileFromAlreadyUploadedFiles(fileUid,name)
                }else{
                  return false;
                }
              }
            },
            discardSelectedFileFromAlreadyUploadedFiles(fileUid,name){
              if(confirm(`Are you sure you want to Delete this attached file?`)){
                if(this.attachedFilesList && fileUid)this.attachedFilesList = this.attachedFilesList.filter(e => e.file_uid != fileUid);
                if(this.uploadedFilesList && fileUid)this.uploadedFilesList = this.uploadedFilesList.filter(e => e.fileUID != fileUid);
                if(name && this.file_name_data_temp_list){
                  this.file_name_data_temp_list = this.file_name_data_temp_list.filter(e => e.name != name)
                }
                if(this.uploadedFilesList.length == 0){
                  this.file_name_data_temp_list = [];
                }
                  this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList);
                }else{
                  return false;
                } 
            },
            handleExit(data){
                this.handleUploadExit(data.jobId)
                this.startUpload();
            },
            handleCompleted(){
              this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList);
            },
            handleProgress(data){
                this.uploadedFilesList = Object.values(this.getAllJobs);
                this.uploadPercentage = data.uploadedPercentages
                this.bandWidth = data.bandwidth;
            },
            handleSuccess(data){
                this.uploadedFilesList = Object.values(this.getAllJobs);
                this.uploadPercentage = data.uploadedPercentage;
                // this.$nextTick(()=>{
                //   alert("success")
                //   this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList);
                // })
            },
            handleFail(){
                this.uploadPercentage = -1
            },
            humaniseSize(bytes){
                let data = Utils.humanizeSize(bytes)
                return `${data["value"]} ${data["unit"]}`
            },
            openPictureInPicture(fileInfo){
              this.$emit("openPipOfAttachment",fileInfo)
            },
            openPreviewOfMedia(fileInfo){
              this.$emit("openPipOfAttachment",fileInfo)
            },
            handleDownloadAction(fileInfo){
                let payload = {};
                if(fileInfo.parent_path){
                  payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_path);
                }else if(fileInfo.parent_id_path){
                  payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_id_path);
                }
                payload.element_type = "file";
                payload.job_name = "Download";
                payload.file_name = fileInfo.file_name;
                payload.path = fileInfo.path;
                let fileName = fileInfo.file_name;
                this.initiateDownloadJob(payload).then((data) => {
                    let jobIdFromResponse = data.job_id;
                    let payload = { job_id: "job_id=" + jobIdFromResponse };
                    let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
                    const link = document.createElement("a");
                    link.href = downnloadUrl;
                    link.download = fileName;
                    link.click(); 
                    if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
                        console.log("Share asset Download initiated");
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            },
            getUploadDetailsThroughPath(callback){
                let payload = {};
                if(Object.keys(this.getStartUpDataFromInCache).includes("upload_settings") && this.getStartUpDataFromInCache["upload_settings"][0].upload_path != undefined && this.getStartUpDataFromInCache["upload_settings"][0].upload_path.length){
                  if(this.customUploadPath && Object.keys("customUploadPath").length>0 && 'uploadPath' in this.customUploadPath){
                    payload.folderInfo = {"path":this.customUploadPath.uploadPath};
                  }else{
                    payload.folderInfo = {"path":this.getStartUpDataFromInCache["upload_settings"][0].upload_path};
                  }
                  this.initiateUploadBySubmittingAction(payload).then((data) => {
                    if(data.status == true){
                            this.uploadDetails = {"responseData": data.data, "binId":payload.folderInfo.path.split("share://")[1].split("/")[0]};
                            this.$nextTick(()=>{
                              if(callback && typeof callback == 'function'){
                                callback(this.uploadDetails)
                              }
                            })
                    }else{
                            this.$toast.error(data.message);
                    }
                  });
                }else{
                  alert("Please configure upload path in upload settings");
                  return false;
                }
              
            },
            getThumbnailPath(fileInfo) {
              return Utils.getThumbnailPathfromFileInfo(fileInfo);
            },
            getSvgIconsOfMediaTypes(path, type) {
              return Utils.determineSvgIconForType(path, type);
            },
            isActionEnable(priv){
                return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
            },
            getHumanReadableDuration(duration){
              return Utils.getDurationInSeconds(duration)
            },
            handleVersionUpdatedNotification(notification){
              notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
              let fIndex = this.attachedFilesList.findIndex((e) => e.asset_id == notification.message.asset_id);
              if (fIndex > -1 && this.attachedFilesList[fIndex]) {
                this.$set(this.attachedFilesList[fIndex], 'version_info', notification.message.version_info);
              }
              if(this.latestFileVersions[notification.message.asset_id]){
                this.latestFileVersions[notification.message.asset_id].versions.push(notification.message.version_info[0]);
                this.latestFileVersions[notification.message.asset_id].file_name.push(notification.message.version_info[0]);
              }else{
                this.$set(this.latestFileVersions, notification.message.asset_id,notification.message.version_info[0].files[0]);
              }
            },
            displayProxyOfFile(notification){
              notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
              let proxy_data = notification.message;
              this.mapFileDetailsWithFileUid[proxy_data.file_uid] = proxy_data;
              for(let path of this.uploadedFilesList){
                if(path.fileUID == proxy_data.file_uid){
                  if('thumbnail_uri' in proxy_data.proxy_info){
                    path.proxy_info['thumbnail_uri'] = proxy_data.proxy_info['thumbnail_uri'];
                  }
                  break;
                }
              }

              try{
                    if(this.attachedFilesList && Array.isArray(this.attachedFilesList) && this.attachedFilesList.length){
                        for(let i = 0; i < this.attachedFilesList.length; i++){
                            let message = this.attachedFilesList[i];
                                if(message.file_uid == proxy_data.file_uid){
                                    this.attachedFilesList[i] = proxy_data;
                                    this.$set(this.attachedFilesList[i], 'proxy_info', message);
                                    if(message.proxy_info['thumbnail_uri'] && message.proxy_info['thumbnail_uri'] != proxy_data.proxy_info['thumbnail_uri']){
                                        message.proxy_info['thumbnail_uri'] =  proxy_data.proxy_info['thumbnail_uri'];
                                        break;
                                    }
                                }
                        }
                    }
                }catch(e){
                    console.log('error to update reply list:',e);
                }

                try {
                  if(!this.latestFileVersions[proxy_data.asset_id]) return;
                  if(this.latestFileVersions[proxy_data.asset_id].proxy_info){
                    this.latestFileVersions[proxy_data.asset_id].proxy_info['thumbnail_uri'] =  proxy_data.proxy_info['thumbnail_uri'];
                  }else{
                    this.latestFileVersions[proxy_data.asset_id]['proxy_info'] =  proxy_data.proxy_info;
                  }
                } catch (error) {
                    console.log('error to update reply list:',error);
                }
            },
            handleFileOutdatedNotification(notification){
              notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
              let fIndex = this.attachedFilesList.findIndex((e) => e.asset_id == notification.message.asset_id);
              if (fIndex > -1 && this.attachedFilesList[fIndex]) {
                this.attachedFilesList[fIndex].state = 'OUTDATED';
              }
            },
            annotateAttachment(fileInfo){
               if(fileInfo && !Object.prototype.hasOwnProperty.call(fileInfo,'file_uid'))
                   fileInfo = this.mapFileDetailsWithFileUid[fileInfo.fileUID];
                let isAttachmentOpen = true;
               this.$parent.$emit('annotatateFile',fileInfo,isAttachmentOpen);
            }
        },
        created(){
          try{ //load external plugin manage-versions. below code taken from index.js of then media version plugin
              Utils.loadPluginBundles([{id:'manage_version_bundle_js',jsUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.js`}],'mediaversion-component-loaded').then((event)=>{
                  console.log("[Media version][Event]",event);
                  if(event && Array.isArray(event) && event.length){
                      if(event[0].components['ManageVersionDialog']){
                      const ev = new Event('register-stores-routes');
                      if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                          ev.pluginStore = event[0].pluginStore;
                          parent.document.body.dispatchEvent(ev);
                          Utils.loadCssBundle({id:'manage_version_bundle_css',cssUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.css`});
                          this.$options.components['manage-version'] = event[0].components['ManageVersionDialog'];
                      }
                  }
            });
          }catch(e){console.log(e)}
          if(this.disableAnnotation){
            this.enableAnnotation = false
          }
          if(this.abortInProgressUpload){
            this.isAbortRequested = this.abortInProgressUpload
          }
          this.addWSEventListener({eventname:"FILE_UPDATED", callback:this.displayProxyOfFile,parent:"Attachment"});
          this.addWSEventListener({eventname:"FILE_OUTDATED", callback:this.handleFileOutdatedNotification,parent:"Attachment"});
          this.addWSEventListener({eventname:["VERSION_UPDATED"],
            callback:this.handleVersionUpdatedNotification,
            parent: "attachment"});
          this.emptyOldFiles();
          this.mapUploadedFilesWithUuid[this.uniqueId] = [];
          this.attachedFilesList = this.alreadyAttachedFiles;
          this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList,true);
          if(this.customUploadInfo && Object.keys(this.customUploadInfo).length){
            this.uploadDetails = {"responseData": this.customUploadInfo, "binId":this.customUploadInfo.upload_path.split("share://")[1].split("/")[0]};
            this.$nextTick(()=>{
                if(this.selectedFilesFromAttachBrowse && this.selectedFilesFromAttachBrowse.length){
                  this.selectedFilenames = this.selectedFilesFromAttachBrowse;
                  this.uploadSelectedFileToGivenPath(this.selectedFilenames) 
                }
              })
          }else{
            this.getUploadDetailsThroughPath(()=>{
              if(this.selectedFilesFromAttachBrowse && this.selectedFilesFromAttachBrowse.length){
                this.selectedFilenames = this.selectedFilesFromAttachBrowse;
                this.uploadSelectedFileToGivenPath(this.selectedFilenames) 
              }
            });   
          }
        },
        beforeDestroy(){
          this.removeWSEventListener({eventname:"ASSET_UPDATED", callback:this.displayProxyOfFile,parent:"Attachment"});
          this.removeWSEventListener({eventname:"FILE_OUTDATED", callback:this.handleFileOutdatedNotification,parent:"Attachment"});
          this.removeWSEventListener({eventname:["VERSION_UPDATED"],
            callback:this.handleVersionUpdatedNotification,
            parent: "attachment"});
        }
}
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
    .file-size-display{
      color:$active-blue;
  }
}

.activeFile{
  color:#64a8f0;
}

.activeTag{
    color: $active-blue !important;
}

.upload-fields{
    border: $border-color;
    width: 100%;
    border-radius: 5px;
}

.progress{
  width:85%;
  border: 1px solid #2d2d2d;
  background: #222222;
}

.progress-percentage{
  position: relative;
  bottom: 2px;
  inset-inline-start:3px;
}

.progress-speed{
    position: relative;
    inset-inline-start:2%;
    bottom: 2px;
    color: #666;
    width:100px;
}


.file-name-with-progress-bar-wrapper{
          display: inline-flex;
          width: 100%;
          padding: 8px;
          border:$border-color;
          border-radius: 10px;
          background: $primary-background;
        .file-name-wrapper{
            width: 90%;
            display: inline-block;
            .file-name-display{
                    font-size: 16px;
                    white-space: nowrap;
                    width: 98%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: initial;
                    position: relative;
                    inset-inline-start:0px;
                    top: 2px;
            }
            .progress-bar-wrapper{
                    display: inline-flex;
                    width: 100%;
                    .progress-percentage-display{
                            font-size: 11px;
                    }
                    .progress{
                        width: 70%;
                        background: #292929;
                        margin-inline-start: 4px;
                        height: 10px;
                        margin-top: 2px;
                        border-radius: 3px;
                    }
                    .progress-speed-display{
                            font-size: 11px;
                            margin-inline-start: 3px;
                            width:64px;
                    }
            }
        }
}
.file-upload-status-display-wrapper{
        width:10%;
        .file-upload-status{
            width: 30px;
            height: 30px;
            margin-top: 10px;
        }
    }


.upload-status-text{
    text-align: start;
    float:inline-start;
    font-size:11px;
}

.remove-selected-file{
  visibility:hidden;
}

.file-name-with-progress-bar-wrapper:hover{
  .remove-selected-file{
    visibility: visible;
    position: relative;
    bottom: 2px;
    top:4px;
  }
} 

.storage-type-icons-wrapper{
    visibility: hidden;
    color: #999;
    background: #000000c9;
    min-width: 30px;
    width: auto;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    position: absolute;
    top: 6px;
    inset-inline-end: 6px;
    line-height: 1;
    margin-inline-start: 8px;
    border: unset;
    --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
    box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
    display: flex;
    padding: 2px;
    border-radius: 0.375em;
    svg{
        margin-inline-start: 6px;
        margin-inline-end: 6px;
    }
    a#bd-versions:hover {
        background: transparent;
        border-radius: 0px;
    }
}

.thumbnail-view:hover,.svg-icons-display:hover{
    .storage-type-icons-wrapper{
        visibility: visible;
    }
}


.thumbnail-view{
  position:relative;
  height: 90px;
  width: 160px;
  position: relative;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  border: $border-color;
  border-radius: 8px;
  background: $primary-background;
  img{
    object-fit: contain;
    max-width: 100% !important;
    max-height: 100% !important;
  }
}

.upload-files-count{
    position: sticky;
    top: -1px;
    background: #121212;
    z-index:9;
}

.file-size-display{
    color: #a2a0a0;
    font-size: 11px;
    width: 55px;
    font-weight: 900;
    position: relative;
    top: 1px;
}
.activeDiv{
  border:2px solid $active-blue !important;
  border-radius: 5px;
  img,canvas{
    opacity:1;
  }
}

.custom-thumbanil:hover{
  color:white;
  .replace-uploaded-thumbnail{
    border-radius: 15px;
    background: #333;
  }
}

.change-thumbnail{
    position: absolute;
    border: 1px solid #4a4949;
    inset-inline-end: 19px;
    padding: 0px 10px;
    bottom: 0px;
    background: #333;
}
.unselected-image{
  opacity:0.2;
}

.svg-icons-display {
    height: 20px;
    width: 30px;
    opacity: 0.8;
    margin: 10px;
    position:relative;
}

svg{
  height:60%;
}

.outdated-text{
  position: absolute;
  top: 0px;
  font-weight: 500;
  background: #3a6e8b;
  z-index: 0;
  width: 34px;
  text-align: center!important;
  height: 26px;
  padding-top: 3px;
  inset-inline-start:0px;
  font-size: 13px;
  border-radius: 5px;
}

</style>


